export const PROJECAO_FORM_ID = "projecao-form";
/** Figma 13003:1058436: o modal tem o mesmo título na primeira projeção e na edição. */
export const PROJECAO_TITLE = "Editar Escopo macro";
export const SALVAR_LABEL = "Salvar alterações";
export const CANCELAR_LABEL = "Cancelar";
export const SALVAR_INDISPONIVEL =
  "Para salvar, preencha valor, distribuição por coletor e curva de mensalização de Serviços.";
export const MATERIAIS_INCOMPLETO =
  "Para salvar, preencha também os dados de Materiais ou deixe todos em branco.";
export const CAMPO_NOME = "Nome do Escopo Macro";
export const CAMPO_ORIGEM = "Origem";
export const CAMPO_INICIO = "Início da mensalização";
export const DICA_NOME = "Gerado no Nova Obra";
export const DICA_ORIGEM = "Definida no Nova Obra";
export const DICA_INICIO = (dataInicio: string) =>
  `Baseado na Data de Início da Obra em ${dataInicio}`;
export const PROJECAO_VIGENTE_MESSAGE = "Projeção do escopo macro salva.";
export const PROJECAO_ENVIADA_APROVACAO = "Projeção financeira enviada para aprovação.";
export const PROJECAO_ATUALIZADA_MESSAGE = "Escopo Macro atualizado com sucesso";
export const AVISO_APROVACAO =
  "A alteração vai para aprovação. O valor vigente continua valendo até a aprovação.";
export const SALVAR_SEM_ALTERACAO = "Altere algum dado da projeção para salvar.";
